export default "__VITE_ASSET__8gceUYf6__"